import {IOfferDetail} from "../../offer/types/IOfferDetail";
import {IGtmOffer, IGtmProperty, IGtmRegion} from "../../tracking/google_tag_manager/calculate_gtm_dimensions";
import {gtmInquiry} from "../../tracking/google_tag_manager/gtm_inquiry";
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";
import {ViewType} from "../../view_type/ViewType";
import {ApplicationSource, ApplicationSourceSection} from "../utils/ApplicationSource";

interface IPhoneModalPayload {
    source: ApplicationSource;
}

interface IPhoneModalDetailsPayload {
    region: IGtmRegion;
    offer?: IGtmOffer & {
        status: IOfferDetail["status"];
    };
    property?: IGtmProperty;
    sourceSection: ApplicationSourceSection;
    vendor: {
        name: string;
        id: number;
    };
    viewType: ViewType | null;
    source: ApplicationSource;
    uuid: string | null;
}

export const hitPhoneModalShow = (payload: IPhoneModalPayload) => {
    hitGoogleTagManager({
        event: "modal_push",
        event_action: "show",
        event_category: getEventFromSource(payload.source)
    });
};

export const gtmPhoneModalDetails = (payload: IPhoneModalDetailsPayload) => {
    gtmInquiry(
        payload.viewType,
        {
            financing_services: false,
            source: payload.source,
            source_section: payload.sourceSection,
            uuid: payload.uuid || "",
            direct_marketing_consent: false,
            new_property_notification_consent: false
        },
        "standard",
        payload.vendor,
        payload.region,
        payload.offer,
        payload.property,
        undefined,
        undefined,
        "Push",
        payload.region.country
    );
};

const getEventFromSource = (source: ApplicationSource) => {
    switch (source) {
        case ApplicationSource.OfferPhoneCall:
            return "inwestycja";
        case ApplicationSource.PropertyPhoneCall:
            return "nieruchomość";
        default:
            throw new Error("getEventFromSource wrong source");
    }
};
import {IOfferDetail} from "../../offer/types/IOfferDetail";
import {IGtmOffer, IGtmProperty, IGtmRegion} from "../../tracking/google_tag_manager/calculate_gtm_dimensions";
import {gtmInquiry} from "../../tracking/google_tag_manager/gtm_inquiry";
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";
import {ViewType} from "../../view_type/ViewType";
import {ApplicationSource, ApplicationSourceSection} from "../utils/ApplicationSource";

interface IPhoneModalPayload {
    source: ApplicationSource;
}

interface IPhoneModalDetailsPayload {
    region: IGtmRegion;
    offer?: IGtmOffer & {
        status: IOfferDetail["status"];
    };
    property?: IGtmProperty;
    sourceSection: ApplicationSourceSection;
    vendor: {
        name: string;
        id: number;
    };
    viewType: ViewType | null;
    source: ApplicationSource;
    uuid: string | null;
}

export const hitPhoneModalShow = (payload: IPhoneModalPayload) => {
    hitGoogleTagManager({
        event: "modal_push",
        event_action: "show",
        event_category: getEventFromSource(payload.source)
    });
};

export const gtmPhoneModalDetails = (payload: IPhoneModalDetailsPayload) => {
    gtmInquiry(
        payload.viewType,
        {
            financing_services: false,
            source: payload.source,
            source_section: payload.sourceSection,
            uuid: payload.uuid || "",
            direct_marketing_consent: false,
            new_property_notification_consent: false
        },
        "standard",
        payload.vendor,
        payload.region,
        payload.offer,
        payload.property,
        undefined,
        undefined,
        "Push",
        payload.region.country
    );
};

const getEventFromSource = (source: ApplicationSource) => {
    switch (source) {
        case ApplicationSource.OfferPhoneCall:
            return "inwestycja";
        case ApplicationSource.PropertyPhoneCall:
            return "nieruchomość";
        default:
            throw new Error("getEventFromSource wrong source");
    }
};
